export function hasQualityReportRating(job) {
  const RatingEnum = {
    NORMAL: 1,
    LOW: 2,
    NONE: 3
  };

  if (Object.freeze) {
    Object.freeze(RatingEnum);
  }

  if (
    job &&
    job.workLocationExact &&
    job.payscale_job_info &&
    job.payscale_job_info.Reports &&
    job.payscale_job_info.Reports.payReport &&
    job.payscale_job_info.Reports.payReport.reports
  ) {
    const reportRating = job.payscale_job_info.Reports.payReport.reports.reportRating;

    if (!job.payscale_job_info.Reports.payReport.reports.basePayReport) {
      return RatingEnum.NONE;
    }

    // US and Canada are not part of the data quality metric
    if (job.workLocationExact.match(/United States/i) || job.workLocationExact.match(/Canada/i)) {
      return RatingEnum.NORMAL;
    }

    if (reportRating && reportRating >= 0.18) {
      return RatingEnum.NORMAL;
    }

    if ((reportRating && reportRating < 0.18) || reportRating === 0) {
      return RatingEnum.LOW;
    }
  }

  return RatingEnum.NONE;
}
